import React, { ReactNode, useEffect, useState } from 'react';
import { RecommendationType } from '@/@types';
import { useLingui } from '@lingui/react';
import clsx from 'clsx';
import useLike from '@/components/core/hooks/use-like';
import InternalLink from '@/components/core/components/organism/internal-link';
import { useLocalizedLinks } from '@/components/core/hooks';
import { UIComponent } from '../..';
import { Avatar } from '../../atoms';
import * as styles from './comment.styles';
import Like from '../../molecules/like';

const FormatedDate = ({ value }) => {
  const { i18n } = useLingui();
  const [render, setRender] = useState<ReactNode>('  ');
  useEffect(() => {
    setRender(i18n.date(new Date(value), { hour12: true, hour: '2-digit', minute: '2-digit', year: 'numeric', month: '2-digit', day: '2-digit' }));
  }, [value, i18n]);
  return render;
};

const Comment: UIComponent<{ comment: RecommendationType }> = ({ comment, className }) => {
  const [likes, like, likeClassname] = useLike(comment);
  const links = useLocalizedLinks();
  return (
    <div className={clsx(className, styles.comment)}>
      <div className={styles.header}>
        <Avatar src={comment.user.avatar} size={46} className={styles.avatar} level={comment.user.level?.name} />
        <span className={styles.info}>
          <span className={styles.date}>
            <FormatedDate value={comment.createdAt} />
          </span>
          <InternalLink lines={1} href={links.profile(comment.user).root} className={styles.nickname}>
            {comment.user.nickname}
          </InternalLink>
        </span>
        <span className={styles.like}>
          <span>{likes}</span>
          <Like onClick={like} className={likeClassname} />
        </span>
      </div>
      <div className={styles.message}>{comment.message}</div>
    </div>
  );
};

export default Comment;
